export const initialFromDate = (fromDate) => {
  if (fromDate) return fromDate;
  else {
    const today = new Date();
    const formattedDate = `${new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
      .format(today)
      ?.split('/')
      ?.reverse()
      ?.join('/')}T00:00:00`;
    return formattedDate;
  }
};

export const tabChannel = new BroadcastChannel('navigation-tabs');

const persianDigits = '۰۱۲۳۴۵۶۷۸۹'
export const toPersianDigits = (value) =>
  String(value).replace(/\d/g, (digit) => persianDigits[Number(digit)])
